export const SAUNA_ENQUIRY_OPTIONS = [
  "Sauna — Advise & Design",
  "Sauna — Supply",
  "Sauna — Install",
  "Sauna — Maintenance & Repair",
];
